import * as apiClient from './apiClient';
import * as bootstrap from './bootstrap';
import * as eventQueue from './eventQueue';
import * as inboxBridge from './inboxBridge';
import { getInstallationId } from './installationIdentity';
import {
  deliversWithFcm,
  PROVIDER_MODES,
  registersFcm,
  registersWeb,
} from './modes';
import { readPermissionStatus } from './permissionSync';
import { captureLaunch } from './serviceWorker';

const NotificationsV2 = {
  start: bootstrap.start,
  startDelivery: bootstrap.startDelivery,
  captureLaunch,
  events: eventQueue,
  inbox: inboxBridge,
  onLogin: bootstrap.onLogin,
  onLogout: bootstrap.onLogout,
  syncEndpoint: bootstrap.syncEndpoint,
  syncPermission: bootstrap.syncPermission,
  requestPermission: bootstrap.requestPermission,
  getPushAvailability: bootstrap.getPushAvailability,
  getProviderMode: bootstrap.getProviderMode,
  getBrandConfig: bootstrap.getBrandConfig,
  getState: bootstrap.getState,
  getInstallationId,
  readPermissionStatus,
  api: apiClient,
  PROVIDER_MODES,
  registersFcm,
  registersWeb,
  deliversWithFcm,
};

export default NotificationsV2;
